// SessionExpiredModal.js
import React from "react";
import { ErrorOutline } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

export default function SessionExpiredModal({
  open,
  onConfirm,
  title = "New Login Detected",
  message = "Your account has been accessed from another device or browser.",
  description = "For security reasons, this session has been logged out. Please log in again to continue.",
  confirmText = "Login",
}) {
  return (
    <Dialog open={open} disableEscapeKeyDown
     sx={{
        '& .MuiDialog-paper': {
          width: '360px', // Custom width
          height: '320px', // Custom height
          borderRadius: '16px', // Rounded corners
          backgroundColor: '#FFEAE9', // Custom background color
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)', // Custom shadow
        },
      }}
    >
        <DialogTitle sx={{textAlign: 'center'}}>
               <Box>
                   <ErrorOutline sx={{fontSize:'30px',color:'#B3261E'}}/>
                   <Typography sx={{color:'#B3261E',fontSize: '18px',}}>{title}</Typography>
               </Box>
               </DialogTitle>
      
      <DialogContent>
        <Typography sx={{ textAlign: 'left', mb: 2 ,fontSize: '14px',}}>
          {message}
        </Typography>
        <Typography sx={{ textAlign: "left",fontSize: '14px', }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ textAlign:'right' }}>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{color:'#1c4e50', background:"none",border:'none',boxShadow:'none',fontSize: '15px', }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
